export const CALC_API_DEBOUNCE_DURATION = 500;

export const DATA_STORAGE_KEY = 'GRAWE:react:forms:bike-insurance:data';
export const PAYMENT_STORAGE_KEY = 'GRAWE:react:forms:bike-insurance:payment';

export const DATE_ERROR_MESSAGES = {
  min14years: 'Versicherter muss mindestens das 14. Lebensjahr vollendet haben.',
  inFuture: 'Eingegebenes Datum muss in der Vergangenheit liegen!',
  inPast: 'Eingegebenes Datum muss in der Zukunft liegen!',
  max90daysInFuture: 'Eingegebenes Datum darf maximal 90 Tage in der Zukunft liegen.'
};

export const PAYMENT_SEPA = 'sepa';
export const PAYMENT_PAYMENT_SLIP = 'erlagschein';

export const PAYMENT_TYPE_ANNUAL = 1;
export const PAYMENT_TYPE_BIANNUAL = 2;
export const PAYMENT_TYPE_QUARTERLY = 4;
export const PAYMENT_TYPE_MONTHLY = 12;
